export const isMalaysia = () => {
  return process.env.country === "malaysia";
};

export const isChina = () => {
  return process.env.country === "china";
};
